/* eslint-disable no-param-reassign */
import { createSlice } from '@reduxjs/toolkit';

const vehicleIdSlice = createSlice({
	name: 'vehicleId',
	initialState: '',
	reducers: {
		setVehicleId(state, action) {
			return action.payload;
		}
	}
});

export const { setVehicleId } = vehicleIdSlice.actions;

export default vehicleIdSlice.reducer;
